import { ZapierAgentWorkflow } from "@zapier/canvas-state";

export const getUniqueAgentWorkflowApps = (
  workflow?: ZapierAgentWorkflow,
): string[] => {
  if (!workflow) {
    return [];
  }

  const trigger = workflow.trigger;
  const actions = workflow.actions;

  const controls = [trigger, ...(actions ?? [])];

  const seen = new Set<string>();
  return controls
    .filter((control) => {
      if (!control) return false;
      if (seen.has(control.selected_api)) return false;
      seen.add(control.selected_api);
      return true;
    })
    .map((control) => control!.selected_api);
};
